import styled from 'styled-components';
import { BodyRegularS, CaptionRegularM, LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';
import Arrow from '@/assets/icons/arrowRightIcon.svg?react';

export const TileCont = styled.div`
  min-height: 40px;
  padding: 12px 32px;

  ${({ theme }: IThemeProvider) => `
    border-bottom: 1px solid ${theme.colors.neutral.primary[40]};

    &:last-of-type {
      border: none;
    }
  `}
`;

export const TitleCont = styled.div`
  display: flex;
  cursor: pointer;
`;

export const Title = styled(BodyRegularS)``;

export const ArrowCont = styled.div`
  width: 24px;

  svg {
    height: 12px;
    width: 8px;
  }
`;

interface IExpandIcon {
  isExpanded: boolean;
  theme: ITheme;
}

export const ExpandIcon = styled(Arrow)<IExpandIcon>`
  ${({ isExpanded }: IExpandIcon) => `
    ${isExpanded && 'transform: rotate(90deg);'};
  `}
`;

interface ICheckQuestionCont {
  color: string;
  theme: ITheme;
}

export const CheckQuestionCont = styled.div<ICheckQuestionCont>`
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  ${({ theme, color }: ICheckQuestionCont) => `
    margin: ${theme.layout.spacing.centy} 0 0 0;
    padding: 0 0 0 ${theme.layout.spacing.decy};
    border-left: 4px solid ${color};
    background: ${theme.colors.primary[10]};
  `}
`;

export const CheckQuestionPrefix = styled(LabelRegularBoldM)`
  padding: 0 5px 0 0;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const CheckQuestion = styled(LabelRegularBoldM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `}
`;

interface IRecommendationCont {
  theme: ITheme;
  isLast: boolean;
  isFirst: boolean;
}

export const RecommendationCont = styled.div<IRecommendationCont>`
  display: flex;
  ${({ theme, isLast, isFirst }: IRecommendationCont) => `
    padding: ${isFirst ? theme.layout.spacing.centy : theme.layout.spacing.mikro} 0 ${
  theme.layout.spacing.mikro
} ${theme.layout.spacing.decy};
  `}
`;

export const RecommendationText = styled(CaptionRegularM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
